import { TagApi } from '@movilizame/networking';
import store from '@/store';

export class UserApi {

    /** USERS API  */
    constructor (net, list) {
        this.net = new TagApi(net, list);
    }

    /**
     * Register an user.
     * @param {Object} data {
     *    @param {String} nombre
     *    @param {String} apellido
     *    @param {String} email
     *    @param {String} password
     *    @param {String} password_confirmation
     *    @param {Number} zona_id
     *    @param {Boolean} terms
     *  }
     * @return {}
     */
    register (data) {
        return this.net.post('/api/users', data);
    }

    /**
     * Update a driver.
     * @param {Object} data {
     *    @param {String} email
     *    @param {Number} radio_recepcion
     *    @param {String} password
     *    @param {String} password_confirmation
     *  }
     * @return {}
     */
    updateDriver (data) {
        return this.net.post('/api/conductor/usuario', data);
    }

    /**
     * Update a passenger.
     * @param {Object} data {
     *    @param {String} nombre
     *    @param {String} apellido
     *    @param {Number} zona_id
     *    @param {String} password
     *    @param {String} password_confirmation
     *  }
     * @return {}
     */
    updatePassenger (data) {
        return this.net.post('/api/pasajero/usuario', data);
    }

    getDriverProfile () {
        return this.net.get('/api/conductor/usuario');
    }

    getPassengerProfile () {
        return this.net.get('/api/pasajero/usuario');
    }

        /**
     * Update user photo.
     *    @param {Object} data {
     *    @param {File} profile (Image)
     *  }
     * @return {}
     */
    updatePhoto (data) {
        let token = store.getters['auth/token'];
        return this.net.post('/api/foto' + '?token=' + token, data);
    }
}



// WEBPACK FOOTER //
// ./src/services/api/User.js